<template>
  <div class="policy-descriptions" v-bind:class="[{loaded: !loading}, policyIdClass]">
    <Skeleton v-if="loading" :height="20" :width="150"></Skeleton>

    <div v-if="!loading">
      <div v-for="(description, key) in descriptions" :key="key">
        <!-- FIXME: use discription component EG. licenseplateComponent a.o.  -->
        <div v-html="sanitizeDescription(description)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import policyApi from '~/api/policy'
import { Skeleton } from 'vue-loading-skeleton'
import DOMPurify from "dompurify";

export default {
  name: 'PolicyDescriptionComponent',
  components: { Skeleton },
  props: {
    policyId: {
      type: Number,
      required: true
    },
  },
  data () {
    return {
      descriptions: [],
      loading: true
    }
  },
  computed: {
    policyIdClass () {
      return 'policy-' + this.policyId
    }
  },
  methods: {
    loadDescriptions () {
      policyApi.getById(this.policyId)
          .then(response => {
            this.descriptions = response.data.descriptions

          })
          .catch(error => {
          })
          .finally(() => {
            this.loading = false
          })
    },
    sanitizeDescription(description) {
      return DOMPurify.sanitize(description, {ADD_TAGS: ['kenteken']});
    },
  },
  mounted () {
    this.loadDescriptions()
  }
}
</script>

<style scoped>

</style>
